export default __webpack_public_path__ + "static/media/contributeUnwantedStuff.155fe922.png";